<template>
  <b-container
    :fluid="true"
    class="px-0"
    :style="{ margin: (loading || error) ? '0 !important' : 'auto'}"
    v-cloak
  >
    <form @submit.prevent="valid">
      <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
        <Loading />
      </div>
      <div v-else-if="error" class="min-vh-100 d-flex align-items-center justify-content-center">
        <div style="max-width: 400px;">
          <h4 class="text-2xl text-gray-500 font-weight-bold">
            Shipment Not Found
          </h4>
          <p class="text-gray-700">
            Shipment with id <span class="badge badge-primary">{{ $route.params.id }}</span> could
            not be found. Make sure that there are no typos in the shipment id.
          </p>
          <b-button
            class="d-flex align-items-center mx-auto"
            @click="$router.go(-1)"
          >
            <b-icon-chevron-left font-scale="0.8" />
            BACK
          </b-button>
        </div>
      </div>
      <fieldset v-else :disabled="can('Booking Details', 'read only')">
      <b-row class="px-3">
        <b-col
          cols="auto"
          class="pr-0 position-fixed d-none d-md-flex align-items-center"
          style="top: 10px; z-index: 1; height: calc(100vh - 20px);"
        >
          <div>
            <ShipmentNavProgress
              :card-names="cardNamesOrdered"
            ></ShipmentNavProgress>
          </div>
        </b-col>
        <b-col class="col ml-md-5" lg="8" id="content">
          <ShipmentPrototypeCard v-if="$route.params.id" name="invoice"
           v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <!-- <h6>INVOICE #/ CONTAINER #</h6> -->
              <h6>INVOICE #/ BILL OF LADING #</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <div>
                      <label class="col-form-label floating-label active" for="Invoice">Invoice #
                      </label>
                      <label class="col-form-label floating-label" for="Invoice">{{ response.id }}
                      </label>
                    </div>
                    <!-- <div v-else>
                      <label class="col-form-label floating-label" for="Invoice">Invoice #
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="Invoice"
                        name="Invoice"
                        type="text"
                        v-model="response.id"
                      >
                    </div> -->
                  </b-col>
                  <!-- <b-col class="floating-label-container">
                    <div v-if="$route.params.id">
                      <label class="col-form-label floating-label active" for="Container">
                        Container #
                      </label>
                      <label class="col-form-label floating-label" for="Container">
                        {{ response.pickupDetails.container }}
                      </label>
                    </div>
                    <div v-else>
                      <label class="col-form-label floating-label" for="Container">Container #
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="Container"
                        name="Container"
                        type="text"
                        v-model="response.pickupDetails.container"
                      >
                    </div>
                 </b-col> -->
                </b-row>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="sender" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>SENDER</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="shipperFirst">First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="shipperFirst"
                      name="shipperFirst"
                      type="text"
                      v-model="response.shipper.firstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="shipperLast">Last Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="shipperLast"
                      name="shipperLast"
                      type="text"
                      v-model="response.shipper.lastName"
                    >
                 </b-col>
                </b-row>

                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="address">Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="address"
                    name="address"
                    type="text"
                    v-model="response.shipper.address"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label active"
                    for="sender-country">Country</label>
                  <!-- <input
                    required
                    class="form-control text-center"
                    id="sender-country"
                    name="sender-country"
                    type="text"
                    v-model="response.shipper.country"
                  > -->
                  <country-select class="form-control text-center"
                  required
                  id="sender-country"
                  countryName="true"
                  placeholder=""
                  v-model="response.shipper.country" :country="response.shipper.country"
                  topCountry="US" />
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="city">City</label>
                    <input
                      required
                      class="form-control text-center"
                      id="city"
                      name="city"
                      type="text"
                      v-model="response.shipper.city"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="state">State</label>
                    <input
                      required
                      class="form-control text-center"
                      id="state"
                      name="state"
                      type="text"
                      v-model="response.shipper.state"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="zip-code">Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="zip-code"
                      name="zip-code"
                      type="text"
                      v-model="response.shipper.zipCode"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="airportcode">
                    Airport Code</label>
                  <input
                    required
                    class="form-control text-center"
                    id="shipper-airportcode"
                    name="shipper-airportcode"
                    type="text"
                    v-model="response.shipper.airportCode"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="sender-email">Email</label>
                  <input
                    class="form-control text-center"
                    id="sender-email"
                    name="sender-email"
                    type="email"
                    v-model="response.shipper.email"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="sender-phone">Phone</label>
                  <input
                    required
                    class="form-control text-center"
                    id="sender-phone"
                    name="sender-phone"
                    type="text"
                    v-model="response.shipper.phone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="consignee" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>CONSIGNEE</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consigneeFirst">First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="consigneeFirst"
                      name="consigneeFirst"
                      type="text"
                      v-model="response.consignee.firstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consigneeLast">Last Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="consigneeLast"
                      name="consigneeLast"
                      type="text"
                      v-model="response.consignee.lastName"
                    >
                 </b-col>
                </b-row>

                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label"
                    for="consignee-address"
                  >Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-address"
                    name="consignee-address"
                    type="text"
                    v-model="response.consignee.address"
                  >
                </div>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="consignee-country"
                  >Country</label>
                  <!-- <input
                    required
                    class="form-control text-center"
                    id="consignee-country"
                    name="consignee-country"
                    type="text"
                    v-model="response.consignee.country"
                  > -->
                  <country-select class="form-control text-center"
                  required
                  id="consignee-country"
                  countryName="true"
                  placeholder=""
                  v-model="response.consignee.country" :country="response.consignee.country"
                  topCountry="US" />
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consignee-city">City</label>
                    <input
                      class="form-control text-center"
                      id="consignee-city"
                      name="consignee-city"
                      type="text"
                      v-model="response.consignee.city"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consignee-state">State</label>
                    <input
                      class="form-control text-center"
                      id="consignee-state"
                      name="consignee-state"
                      type="text"
                      v-model="response.consignee.state"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consignee-zipcode">
                      Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="consignee-zipcode"
                      name="consignee-zipcode"
                      type="text"
                      v-model="response.consignee.zipCode"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="consignee-airportcode">
                    Airport Code</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-airportcode"
                    name="consigneeairportcode"
                    type="text"
                    v-model="response.consignee.airportCode"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="consignee-email">Email</label>
                  <input
                    class="form-control text-center"
                    id="consignee-email"
                    name="consignee-email"
                    type="email"
                    v-model="response.consignee.email"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="consignee-phone">Phone</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-phone"
                    name="consignee-phone"
                    type="text"
                    v-model="response.consignee.phone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="agent" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>AGENT</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <v-select
                @input="setSelected"
                v-model="selectedAgent"
                :disabled="can('Booking Details', 'read only')"
                :filter="fuseSearch"
                :options="agents"
                :get-option-label="(option) => option.name"
              >
                <template #option="{name, airportCode }">
                  <cite>{{ name }} - {{ airportCode }}</cite>
                </template>
              </v-select>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label"
                    :class="{
                      'active': selected != '',
                    }"
                    for="agentFirst">First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="agentFirst"
                      name="agentFirst"
                      type="text"
                      v-model="response.agent.firstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label"
                    :class="{
                      'active': selected != '',
                    }"
                    for="agentLast">Last Name
                    </label>
                    <input
                      class="form-control text-center"
                      id="agentLast"
                      name="agentLast"
                      type="text"
                      v-model="response.agent.lastName"
                    >
                 </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label"
                    :class="{
                      'active': selected != '',
                    }"
                    for="agent-address"
                  >Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="agent-address"
                    name="agent-address"
                    type="text"
                    v-model="response.agent.address"
                  >
                </div>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="agent-country"
                    :class="{
                      'active': selected != '',
                    }"
                  >Country</label>
                  <!-- <input
                    required
                    class="form-control text-center"
                    id="agent-country"
                    name="agent-country"
                    type="text"
                    v-model="response.agent.country"
                  >  -->
                  <country-select class="form-control text-center"
                  required
                  style="color:gray;"
                  id="agent-country"
                  placeholder=""
                  countryName="true"
                  v-model="response.agent.country" :country="response.agent.country"
                  topCountry="US" />
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label"
                    :class="{
                      'active': selected != '',
                    }"
                    for="agent-city">City</label>
                    <input
                      class="form-control text-center"
                      id="agent-city"
                      name="agent-city"
                      type="text"
                      v-model="response.agent.city"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label"
                    :class="{
                      'active': selected != '',
                    }"
                    for="agent-state">State</label>
                    <input
                      class="form-control text-center"
                      id="agent-state"
                      name="agent-state"
                      type="text"
                      v-model="response.agent.state"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label"
                    :class="{
                      'active': selected != '',
                    }"
                    for="agent-zipcode">
                      Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="agent-zipcode"
                      name="agent-zipcode"
                      type="text"
                      v-model="response.agent.zipCode"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label"
                  :class="{
                      'active': selected != '',
                    }"
                  for="agent-phone">Phone</label>
                  <input
                    required
                    class="form-control text-center"
                    id="agent-phone"
                    name="agent-phone"
                    type="text"
                    v-model="response.agent.phone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="pickup" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6 class="flex-grow-1 text-center">PICKUP DETAILS</h6>
            </template>
            <template v-slot:body>
              <div class="mx-1 mx-md-5">
                <div style="max-width: 20%;">
                  <b-row>
                    <b-col class="floating-label-container">
                      <b-form-select
                        required
                        id="pickup-type"
                        v-model="response.pickupDetails.pickupMode"
                        :options="pickupTypes"
                        class="text-center"
                      ></b-form-select>
                    </b-col>
                  </b-row>
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="pickup-driver">
                    Pickup Driver
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="pickup-driver"
                    name="pickup-driver"
                    type="text"
                    v-model="response.pickupDetails.driver"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="address">
                    Pickup Office Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="address"
                    name="address"
                    type="text"
                    v-model="response.pickupDetails.address"
                  >
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="office-city">
                      Pickup Office City</label>
                    <input
                      required
                      class="form-control text-center"
                      id="office-city"
                      name="office-city"
                      type="text"
                      v-model="response.pickupDetails.city"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="office-state">
                      Pickup Office State</label>
                    <input
                      required
                      class="form-control text-center"
                      id="office-state"
                      name="office-state"
                      type="text"
                      v-model="response.pickupDetails.state"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="office-zipcode">
                      Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="office-zipcode"
                      name="office-zipcode"
                      type="text"
                      v-model="response.pickupDetails.zipCode"
                    >
                  </b-col>
                </b-row>
                <!-- <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="office-code">
                    Airport Code</label>
                  <input
                    required
                    class="form-control text-center"
                    id="airport-code"
                    name="airport-code"
                    type="text"
                    v-model="response.agent.airportCode"
                  >
                </div> -->
                <div class="shipment-list-item px-3">
                  <div class="text-muted">
                    PICKUP TIME
                  </div>
                  <div>
                    <div class="d-inline-block">
                      <b-form-datepicker
                        required
                        reset-button
                        v-model="response.pickupDetails.pickupStartTime"
                        class="normalize text-center"
                        :max="maxStartDate"
                        :state="isStartDateValid"
                      ></b-form-datepicker>
                    </div>
                    <div class="d-inline-block">
                      <b-form-timepicker
                        required
                        reset-button
                        v-model="pickupStartTime"
                        class="normalize"
                        locale="en"
                        :state="isStartTimeValid"
                      ></b-form-timepicker>
                    </div>
                  </div>
                  <p>-</p>
                  <div>
                    <div class="d-inline-block">
                      <b-form-datepicker
                        required
                        reset-button
                        v-model="response.pickupDetails.pickupEndTime"
                        class="normalize text-center"
                        :min="minEndDate"
                        :state="isEndDateValid"
                      ></b-form-datepicker>
                    </div>
                    <div class="d-inline-block">
                      <b-form-timepicker
                        required
                        reset-button
                        v-model="pickupEndTime"
                        class="normalize"
                        locale="en"
                        :state="isEndTimeValid"
                      ></b-form-timepicker>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <b-btn
                    variant="outline-dark"
                    class="text-xs mx-2"
                    @click="visiblePickupNote = !visiblePickupNote"
                  >
                    {{ noteStatus }} Note
                  </b-btn>
                </div>
                <b-collapse
                  :id="'pickup-note-button'"
                  :visible="visiblePickupNote"
                  ref="pickup-note-collapse"
                >
                  <div class="d-flex justify-content-center mt-2">
                    <div style="width: 100%;" ref="pickupInstructions">
                      <b-form-textarea
                        id="delivery-notes"
                        v-model="response.pickupDetails.pickupNote"
                        rows="1"
                        max-rows="6"
                        style="width: 90%; margin: auto; border: 2px solid lightgray;
                           border-radius: 5px;"
                      ></b-form-textarea>
                    </div>
                  </div>
                </b-collapse>
                <div class="d-flex justify-content-center my-2">
                  <b-btn
                    variant="outline-dark"
                    class="text-xs mx-2"
                    @click="visiblePickupRemark = !visiblePickupRemark"
                  >
                    {{ remarkStatus }} Remark
                  </b-btn>
                </div>
                <b-collapse
                  :id="'pickup-remark-button'"
                  :visible="visiblePickupRemark"
                  ref="pickup-remark-collapse"
                >
                  <div class="d-flex justify-content-center mt-2">
                    <div style="width: 100%;" ref="pickupRemark">
                      <b-form-textarea
                        id="delivery-remark"
                        v-model="response.pickupDetails.pickupRemark"
                        rows="1"
                        max-rows="6"
                        style="width: 90%; margin: auto; border: 2px solid lightgray;
                           border-radius: 5px;"
                      ></b-form-textarea>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="items" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <div class="position-relative d-flex justify-content-center align-items-center">
                <div
                  class="dropdown position-absolute left-15"
                  :class="{show: flagDropdownVisible}"
                >
                  <button
                    class="btn btn-secondary dropdown-toggle rounded-pill text-xs mx-2"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    :aria-expanded="flagDropdownVisible"
                    @click.stop="flagDropdownVisible = !flagDropdownVisible"
                  >
                    <b-icon-flag-fill
                      :style="{
                        color: response.itemDetails.flag ?
                         flagColor[response.itemDetails.flag] : '#eeeeee',
                        }"
                    ></b-icon-flag-fill>
                  </button>
                  <div
                    class="dropdown-menu text-xs border-0 shadow-lg"
                    :class="{show: flagDropdownVisible}"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <b-dropdown-item
                      link-class="d-flex justify-content-between align-items-center px-3"
                      @click.stop="() => {
                        response.itemDetails.flag = (response.itemDetails.flag === 'delayed'
                          ? ''
                          : 'delayed');
                        flagDropdownVisible = false;
                      }"
                    >
                      <div>
                        <b-icon-flag-fill
                          style="color: #d476fd"
                        ></b-icon-flag-fill>
                        Delayed
                      </div>
                      <b-icon-check v-if="response.itemDetails.flag === 'delayed'"></b-icon-check>
                    </b-dropdown-item>
                    <b-dropdown-item
                      link-class="d-flex justify-content-between align-items-center px-3"
                      @click.stop="() => {
                        response.itemDetails.flag = (response.itemDetails.flag === 'pickup'
                          ? ''
                          : 'pickup');
                        flagDropdownVisible = false;
                      }"
                    >
                      <div>
                        <b-icon-flag-fill
                          style="color: #f1c32b"
                        ></b-icon-flag-fill>
                        Pick Up Error
                      </div>
                      <b-icon-check v-if="response.itemDetails.flag === 'pickup'"></b-icon-check>
                    </b-dropdown-item>
                    <b-dropdown-item
                      link-class="d-flex justify-content-between align-items-center px-3"
                      @click.stop="() => {
                        response.itemDetails.flag = (response.itemDetails.flag === 'other'
                          ? ''
                          : 'other');
                        flagDropdownVisible = false;
                      }"
                    >
                      <div>
                        <b-icon-flag-fill
                          style="color: #8abdd0"
                        ></b-icon-flag-fill>
                        Other Error
                      </div>
                      <b-icon-check v-if="response.itemDetails.flag === 'other'"></b-icon-check>
                    </b-dropdown-item>
                  </div>
                </div>
                <h6>ITEMS</h6>
              </div>
            </template>
            <template v-slot:body>
              <ShipmentPrototypeItemList
                :items="response.itemDetails.items"
                @add="addNewItem"
                @remove="removeItem"
                @toggleHazard="toggleHazard"
                @updateSeal="updateSeal"
                @calculateVolume="calculateVolume"
              ></ShipmentPrototypeItemList>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="charges" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>CHARGES</h6>
            </template>
            <template v-slot:body>
              <hr/>
              <div>
              <div style="max-width: 20%;" class="my-3 mx-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <b-form-select
                      required
                      id="delivery-type"
                      v-model="response.itemDetails.shippingTerm"
                      :options="deliveryTypes"
                      class="text-center"
                    ></b-form-select>
                  </b-col>
                  <b-col class="floating-label-container">
                    <b-form-select
                      required
                      id="travel-mode"
                      v-model="response.itemDetails.travelMode"
                      :options="travelMode"
                      class="text-center"
                  ></b-form-select>
                  </b-col>
                </b-row>
              </div>
            </div>
              <ShipmentPrototypeChargesList
                :items="response.chargeDetails.charges"
                @add="addNewCharge"
                @remove="removeCharge"
              ></ShipmentPrototypeChargesList>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="payments"
          v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>PAYMENTS</h6>
            </template>
            <template v-slot:body>
              <ShipmentPrototypePaymentList
                :items="response.payments"
                @add="addNewPayment"
                @remove="removePayment"
              ></ShipmentPrototypePaymentList>
            </template>
          </ShipmentPrototypeCard>
          <div v-if="$route.params.id">
            <ShipmentPrototypeCard name="update" v-observe-visibility="visibilityChanged">
                <template v-slot:title>
                  <h6>FINAL STEP</h6>
                </template>
                <template v-slot:body>
                  <b-button type="update" block class="mb-2 shipment-create-button w-50 m-auto"
                  :disabled="processing">
                    <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                    UPDATE SHIPMENT
                  </b-button>
                </template>
              </ShipmentPrototypeCard>
          </div>
          <div v-else>
             <ShipmentPrototypeCard name="submit" v-observe-visibility="visibilityChanged">
                <template v-slot:title>
                  <h6>FINAL STEP</h6>
                </template>
                <template v-slot:body>
                  <b-button type="submit" block class="mb-2 shipment-create-button w-50 m-auto"
                  :disabled="processing">
                    <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                    CREATE SHIPMENT
                  </b-button>
                </template>
              </ShipmentPrototypeCard>
          </div>

        </b-col>
        <b-col col class="h-100 position-sticky d-none d-lg-block" style="top: 10px;">
  <!--   :href="'/search?' + 'accountNumber=' + accountNumber + '&name=' + name + '&phoneNumber='-->
  <!--    + phoneNumber + '&destination=' + destination + '&bol=' + bol"-->
          <div>
            <b-button
              v-if="backToSearch"
              variant="secondary"
              block
              class="mb-3"
              @click="$router.go(-1)"
            >
              <h5 class="text-light">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                <span class="ml-3">BACK</span>
              </h5>
            </b-button>
            <ShipmentPrototypeCard name="summary" :collapsible="false">
              <template v-slot:title>
                <h6 class="font-weight-bold">SUMMARY</h6>
              </template>
              <template v-slot:body>
                <hr class="mt-0 mb-2"/>
                <div v-if="response.shipper.firstName && response.consignee.firstName">
                  <div class="text-sm text-muted">
                    <span>Sender</span>
                    <b-icon-arrow-right-short></b-icon-arrow-right-short>
                    <span>Consignee</span>
                  </div>
                  <mark><b>{{ `${response.shipper.firstName} ${response.shipper.lastName}` }}</b>
                  </mark>
                  <b-icon-arrow-right-short></b-icon-arrow-right-short>
                  <mark><b>{{ `${response.consignee.firstName} ${response.consignee.lastName}` }}
                  </b></mark>
                  <hr class="my-2"/>
                </div>
                <div v-if="totalCount > 0">
                  <div>
                    <b-icon-box-seam class="mr-2"></b-icon-box-seam>{{ mostCommonReference }}
                  </div>
                  <div style="font-size: smaller;">
                    {{ totalCount }} <b-icon-x></b-icon-x> items
                    <b-icon-dot></b-icon-dot>
                    {{ totalWeight }} lbs
                    <b-icon-dot></b-icon-dot>
                    {{ totalVolume }} in<sup>3</sup>
                  </div>
                  <hr class="my-2"/>
                </div>
                <div>
                  <div class="text-xs text-muted">Booked Date</div>
                    <div v-if="$route.params.id">
                      {{ dateCreated }}
                  </div>
                  <div v-else>
                    {{ currentDateTime() }}
                  </div>
                </div>
                <div
                  v-if="response.pickupDetails.pickupStartTime
                    && response.pickupDetails.pickupEndTime"
                >
                  <hr class="my-2"/>
                  <ShipmentPrototypeCard
                    name="status"
                    class="m-0"
                    :visible="false"
                    style="box-shadow: none !important;"
                  >
                    <template v-slot:title>
                      <div class="text-wrap px-5">
                        <div class="text-xs text-muted">
                          Pickup Time
                        </div>
                        <div class="d-flex justify-content-center">
                          <div>{{ formattedPickupStart }}</div>
                          <b-icon-dot></b-icon-dot>
                          <div>{{ formattedPickupEnd }}</div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:body>
                      <div class="mx-3">
                        <hr class="mx-4 my-0"/>
                        <ShipmentStatusProgress
                          :current-status="response.movementStatus"
                          :shipmentData="response"
                          :container="response.container"
                        ></ShipmentStatusProgress>
                      </div>
                    </template>
                  </ShipmentPrototypeCard>
                </div>
                <hr class="my-2"/>
                <div>
                  <div class="text-xs text-muted">
                    Outstanding balance
                  </div>
                  ${{ outstandingBalance }}
                </div>
              </template>
            </ShipmentPrototypeCard>
            <!-- <div class="mt-3 text-center" v-if="outstandingBalance > 0 && $route.params.id">
              <b-button
                variant="success"
                class="shadow-sm mb-2 w-50"
                @click="payWithStripe"
              >
                <b-icon-credit-card class="mr-2" /> Pay with Stripe
              </b-button>
            </div> -->
            <div v-if="$route.params.id">
              <b-button type="update" block class="shadow-sm mb-2 shipment-create-button"
              :disabled="processing">
                <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                UPDATE SHIPMENT
              </b-button>
            </div>
            <div v-else>
              <b-button type="submit" block class="shadow-sm mb-2 shipment-create-button"
              :disabled="processing">
                <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                CREATE SHIPMENT
              </b-button>
            </div>
            <div class="d-inline-flex mt-2">
              <b-button @click="reset" class="shipment-option" title="New Shipment">
                <b-icon-plus></b-icon-plus>
              </b-button>
              <b-button @click="copy" class="shipment-option" title="Copy to New">
                <b-icon-files></b-icon-files>
              </b-button>
              <b-button
                v-b-modal.print
                class="shipment-option"
                title="Print"
              >
                <b-icon-printer></b-icon-printer>
              </b-button>

               <b-modal id="print" ref="printModal" title="Shipment Files" hide-footer>
                <b-button
                    block class="shadow-sm mb-2 shipment-create-button"
                    @click="hideModal($refs.WarehouseReceipt);"
                    title="Warehouse Receipt"
                  >
                    Warehouse Receipt
                  </b-button>
                  <b-button
                    block class="shadow-sm mb-2 shipment-create-button"
                    @click="hideModal($refs.BOLReceipt);"
                    title="BOL Receipt"
                  >
                    BOL Receipt
                  </b-button>
                  <b-button
                    block class="shadow-sm mb-2 shipment-create-button"
                    @click="hideModal($refs.BOLLabel);"
                    title="BOL Label"
                  >
                    BOL Label
                  </b-button>
              </b-modal>

              <b-modal id="confirmation" ref="confirmationModal" centered title="" hide-footer
              hide-header :no-close-on-backdrop="true">
                <div v-if="processing">
                  <Loading />
                </div>
                <div v-else-if="processingError">
                  <div class="d-flex align-items-center justify-content-center">
                    <Cross />
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <h2>Failure</h2>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    {{ processingError }}
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex align-items-center justify-content-center">
                    <Checkmark />
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <h2>Done!</h2>
                  </div>
                </div>
              </b-modal>
              <BOLReceipt name="html2Pdf" :response="response" :currentUser="currentUser"
              :dateCreated="dateCreated" :pickupStartTime="pickupStartTime"
              :token="token"
              ref="BOLReceipt" />
              <WarehouseReceipt name="html2Pdf" :response="response" :currentUser="currentUser"
              ref="WarehouseReceipt" />
              <BOLLabel name="html2Pdf" :response="response" :currentUser="currentUser"
              ref="BOLLabel" />
            </div>
          </div>
        </b-col>
      </b-row>
      </fieldset>
    </form>
  </b-container>
</template>

<script>
import _ from 'lodash';
import { nanoid } from 'nanoid';
import moment from 'moment';
import 'moment-timezone';
import Fuse from 'fuse.js';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import vueCountryRegionSelect from 'vue-country-region-select';
import Vue from 'vue';

import ShipmentPrototypeCard from '../components/ShipmentPrototypeCard.vue';
import ShipmentPrototypeItemList from '../components/ShipmentPrototypeItemList.vue';
import ShipmentPrototypeChargesList from '../components/ShipmentPrototypeChargesList.vue';
import ShipmentPrototypePaymentList from '../components/ShipmentPrototypePaymentList.vue';
import ShipmentStatusProgress from '../components/ShipmentStatusProgress.vue';
import ShipmentNavProgress from '../components/ShipmentNavProgress.vue';
import Loading from '../components/Loading.vue';
import Checkmark from '../components/Checkmark.vue';
import Cross from '../components/Cross.vue';
import {
  getShipmentById, postShipment, updateShipment, tokenize,
} from '../api/shipment';
import createCheckoutSession from '../api/payment';
import { getOffice } from '../api/admin';
import BOLReceipt from '../components/BOLReceipt.vue';
import WarehouseReceipt from '../components/WarehouseReceipt.vue';
import BOLLabel from '../components/BOLLabel.vue';

Vue.use(vueCountryRegionSelect);

export default {
  name: 'ShipmentPrototype',
  data() {
    return this.initialState();
  },
  computed: {
    noteStatus() {
      if (this.visiblePickupNote === false) {
        if (this.response.pickupNote === '') {
          return 'Add';
        }
        return 'Show';
      }
      return 'Save';
    },
    remarkStatus() {
      if (this.visiblePickupRemark === false) {
        if (this.response.pickupRemark === '') {
          return 'Add';
        }
        return 'Show';
      }
      return 'Save';
    },
    cardNamesOrdered() {
      return Object.values(this.cardNames).sort((a, b) => a.order - b.order);
    },
    mostCommonReference() {
      const counter = {};
      this.response.itemDetails.items.forEach((elem) => {
        if (elem.description in counter) {
          counter[elem.description] += 1;
        } else {
          counter[elem.description] = 1;
        }
      });

      let max = -1;
      let maxRef = '';
      Object.entries(counter).forEach(([key, val]) => {
        if (val >= max) {
          maxRef = key;
          max = val;
        }
      });
      return max === -1 ? '' : `${maxRef}...`;
    },
    totalCount() {
      // return this.response.itemDetails.items.length;
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.qty, 0);
    },
    totalWeight() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.weight * curr.qty, 0);
    },
    totalVolume() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.volume * curr.qty, 0);
    },
    outstandingBalance() {
      return this.response.chargeDetails.charges.reduce((acc, curr) => acc + curr.amount, 0)
        - this.response.payments.reduce((acc, curr) => acc + curr.amount, 0);
    },
    backToSearch() {
      return this.accountNumber || this.phoneNumber || this.name || this.destination;
    },
    formattedPickupStart() {
      return this.response.pickupDetails.pickupStartTime.toLocaleString('en-US', { timeStyle: 'short' });
    },
    formattedPickupEnd() {
      return this.response.pickupDetails.pickupEndTime.toLocaleString('en-US', { timeStyle: 'short' });
    },
    minEndDate() {
      return this.response.pickupDetails.pickupStartTime;
    },
    maxStartDate() {
      return this.response.pickupDetails.pickupEndTime;
    },
    // isStartDateValid() {
    //   return this.response.pickupDetails.pickupStartTime !== '';
    // },
    // isEndDateValid() {
    //   return this.response.pickupDetails.pickupEndTime !== '';
    // },
    // () {
    //   return this.pickupStartTime !== '';
    // },
    // isEndTimeValid() {
    //   return this.pickupEndTime !== '';
    // },
  },
  methods: {
    initialState() {
      return {
        currentUser: JSON.parse(localStorage.getItem('user')),
        pickupStartTime: null,
        pickupEndTime: null,
        dateCreated: '',
        isStartDateValid: null,
        isEndDateValid: null,
        isStartTimeValid: null,
        isEndTimeValid: null,
        agents: [],
        token: '',
        selected: false,
        selectedAgent: '',
        response: {
          id: '',
          container: {},
          shipper: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            airportCode: '',
            email: '',
            phone: '',
          },
          consignee: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            airportCode: '',
            email: '',
            phone: '',
          },
          agent: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            airportCode: '',
            email: '',
            phone: '',
          },
          pickupDetails: {
            driver: '',
            address: '',
            city: '',
            state: '',
            zipCode: '',
            pickupStartTime: null,
            pickupEndTime: null,
            pickupNote: '',
            pickupRemark: '',
            pickupMode: 'pickup',
            container: '',
          },
          itemDetails: {
            flag: '',
            shippingTerm: null,
            travelMode: null,
            items: [
              {
                id: 0,
                qty: 1,
                packageType: '',
                description: '',
                weight: 0,
                volume: 0,
                length: 0,
                width: 0,
                height: 0,
                // seal: '',
                seal: [
                  { id: nanoid(6), value: '', flag: true },
                ],
                hazardous: false,
                flag: true,
                selectedWeightType: 'lbs',
                optionsWeightType: [
                  { value: 'lbs', text: 'lbs' },
                  // { value: 'kgs', text: 'kgs' },
                  // { value: 'tons', text: 'tons' },
                ],
                selectedVolumeType: 'in3',
                optionsVolumeType: [
                  { value: 'in3', text: 'in3' },
                  // { value: 'm3', text: 'meters3' },
                ],
                selectedMeasureType: 'in',
                optionsMeasureType: [
                  { value: 'in', text: 'in' },
                  // { value: 'm', text: 'meters' },
                ],
              },
            ],
          },
          chargeDetails: {
            charges: [
              {
                id: 0,
                name: 'Freight',
                amount: 0,
                flag: true,
              },
              {
                id: 1,
                name: 'Pickup',
                amount: 0,
                flag: true,
              },
              {
                id: 2,
                name: 'Handling',
                amount: 0,
                flag: true,
              },
              {
                id: 3,
                name: 'Insurance',
                amount: 0,
                flag: true,
              },
            ],
          },
          payments: [],
          movementStatus: '',
        },
        flagDropdownVisible: false,
        visiblePickupNote: false,
        visiblePickupRemark: false,
        accountNumber: '',
        bol: '',
        phoneNumber: '',
        name: '',
        destination: '',
        print: false,
        loading: true,
        processing: false,
        processingError: '',
        error: false,
        loadingPdf: true,
        deliveryTypes: [
          { value: null, text: 'Delivery Type' },
          { value: 'portToPort', text: 'Port To Port' },
          { value: 'preClearance', text: 'Pre-Clearance' },
          { value: 'doorToDoor', text: 'Door To Door' },
          { value: 'doorToWarehouse', text: 'Door To Warehouse' },
          { value: 'doorToPort', text: 'Door To Port' },
        ],
        pickupTypes: [
          { value: null, text: 'Pickup Type' },
          { value: 'pickup', text: 'Pickup' },
          { value: 'drop-off', text: 'Drop-off' },
        ],
        travelMode: [
          { value: null, text: 'Travel Mode' },
          { value: 'oceanDirect', text: 'Ocean Direct' },
          { value: 'oceanTranshipment ', text: 'Ocean Transshipment' },
          { value: 'air', text: 'Air' },
          { value: 'ground', text: 'Ground' },
        ],
        flagColor: {
          delayed: '#d476fd',
          pickup: '#f1c32b',
          other: '#8abdd0',
        },
        cardNames: {
          invoice: {
            order: 0,
            title: 'Invoice',
            id: 'invoice',
            visible: false,
          },
          sender: {
            order: 1,
            title: 'Sender',
            id: 'sender',
            visible: false,
          },
          consignee: {
            order: 2,
            title: 'Consignee',
            id: 'consignee',
            visible: false,
          },
          agent: {
            order: 3,
            title: 'Agent',
            id: 'agent',
            visible: false,
          },
          pickup: {
            order: 4,
            title: 'Pickup Details',
            id: 'pickup',
            visible: false,
          },
          items: {
            order: 5,
            title: 'Items',
            id: 'items',
            visible: false,
          },
          charges: {
            order: 6,
            title: 'Charges',
            id: 'charges',
            visible: false,
          },
          payments: {
            order: 7,
            title: 'Payments',
            id: 'payments',
            visible: false,
          },
          submit: {
            order: 8,
            title: 'Create Shipment',
            id: 'submit',
            visible: false,
          },
        },
      };
    },
    reset() {
      const agentlist = this.$data.agents;
      Object.assign(this.$data, this.initialState());
      delete this.$route.params.id;
      this.agents = agentlist;
      window.history.pushState({}, null, '#/shipment');
      this.loading = false;
    },
    copy() {
      const agentlist = this.$data.agents;
      const copySelected = this.$data.selected;
      const copyselectedAgent = this.$data.selectedAgent;
      const copy = this.$data.response;
      Object.assign(this.$data, this.initialState());
      this.response.shipper = copy.shipper;
      this.response.consignee = copy.consignee;
      this.response.agent = copy.agent;
      this.response.pickupDetails.driver = copy.pickupDetails.driver;
      this.response.pickupDetails.address = copy.pickupDetails.address;
      this.response.pickupDetails.city = copy.pickupDetails.city;
      this.response.pickupDetails.state = copy.pickupDetails.state;
      this.response.pickupDetails.zipCode = copy.pickupDetails.zipCode;
      // this.response.itemDetails.items = copy.itemDetails.items;
      this.response.itemDetails.items = copy.itemDetails.items.map((item) => {
        const seals = [];
        for (let i = 0; i < item.qty; i += 1) {
          seals.push({ id: nanoid(6), value: '', flag: true });
        }
        return Object.assign(item,
          {
            ...item,
            seal: seals,
          });
      });
      this.agents = agentlist;
      this.selected = copySelected;
      this.selectedAgent = copyselectedAgent;
      delete this.$route.params.id;
      window.history.pushState({}, null, '#/shipment');
      this.loading = false;
    },
    payWithStripe() {
      if (!this.$route.params.id) {
        alert('Please create a shipment first before paying.');
        return;
      }
      const data = {
        shipmentId: this.$route.params.id,
        payoutUserId: this.currentUser.id,
      };
      this.processing = true;
      this.processingError = false;
      this.$refs.confirmationModal.show();
      createCheckoutSession(data)
        .then((resp) => {
          this.processing = false;
          this.$refs.confirmationModal.hide();
          if (resp.data.url) {
            window.location.href = resp.data.url;
          } else {
            this.processingError = 'No checkout URL returned';
          }
        })
        .catch((err) => {
          this.processingError = err.response?.data?.error || 'Error creating checkout session';
          this.processing = false;
        });
    },
    hideModal(file) {
      this.$refs.printModal.hide();
      file.generatePdf();
    },
    setSelected(value) {
      if (value == null) {
        this.selected = false;
        Object.assign(this.response.agent, {
          firstName: '',
          lastName: '',
          address: '',
          country: '',
          city: '',
          state: '',
          zipCode: '',
          airportCode: '',
          email: '',
          phone: '',
        });
      } else {
        this.selected = true;
        Object.assign(this.response.agent, {
          firstName: value.name,
          lastName: '',
          address: value.address,
          country: value.country,
          city: value.city,
          state: value.state,
          zipCode: value.zipCode,
          airportCode: value.airportCode,
          email: '',
          phone: value.phone,
        });
        this.response.agent.country = this.countryFormatter(this.response.agent.country);
        // this.response.agent.firstName = value.name;
      }
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['firstName', 'lastName', 'airportCode'],
        shouldSort: true,
      });
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list;
    },
    currentDateTime() {
      const today = new Date();
      return today.toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short', timeZone: this.currentUser.timezone });
    },
    visibilityChanged(isVisible, entry) {
      if (Object.prototype.hasOwnProperty.call(this.cardNames, entry.target.id)) {
        this.cardNames[entry.target.id].visible = isVisible;
      }
    },
    addNewItem() {
      this.response.itemDetails.items.push({
        id: nanoid(6),
        qty: 1,
        packageType: '',
        description: '',
        weight: 0,
        volume: 0,
        length: 0,
        height: 0,
        width: 0,
        // seal: '',
        seal: [
          { id: nanoid(6), value: '', flag: true },
        ],
        hazardous: false,
        flag: true,
        selectedWeightType: 'lbs',
        optionsWeightType: [
          { value: 'lbs', text: 'lbs' },
          // { value: 'kgs', text: 'kgs' },
          // { value: 'tons', text: 'tons' },
        ],
        selectedVolumeType: 'in3',
        optionsVolumeType: [
          { value: 'in3', text: 'in3' },
          // { value: 'm3', text: 'meters3' },
        ],
        selectedMeasureType: 'in',
        optionsMeasureType: [
          { value: 'in', text: 'in' },
          // { value: 'm', text: 'meters' },
        ],
      });
    },
    removeItem(id) {
      // this.response.itemDetails.items.splice(
      //   this.response.itemDetails.items.findIndex((item) => item.id === id),
      //   1,
      // );
      this.response.itemDetails.items.find(
        (item) => item.id === id,
      ).flag = false;
    },
    updateSeal(id) {
      /* eslint-disable no-unused-expressions */
      const selected = this.response.itemDetails.items.find(
        (item) => item.id === id,
      );

      const newArray = selected.seal.filter((seal) => seal.flag === true);

      // let flag = false;
      let count = newArray.length;

      while (selected.qty < count) {
        const index = selected.seal.indexOf(newArray[count - 1]);
        selected.seal[index].flag = false;
        count -= 1;
      }

      while (selected.qty > count) {
        selected.seal.push({ id: nanoid(6), value: '', flag: true });
        count += 1;
      }
      // if (selected.qty < selected.seal.length) {
      //   flag = true;
      // }

      // while (selected.qty !== count) {
      //   if (flag) {
      //     console.log(flag);
      //     selected.seal[count].flag = false;
      //     // selected.seal.pop();
      //     count -= 1;
      //   } else {
      //     selected.seal.push({ id: nanoid(6), value: '', flag: true });
      //     count += 1;
      //   }
      //   console.log(count);
      // }
    },
    addNewCharge() {
      this.response.chargeDetails.charges.push({
        id: `charge-${nanoid(6)}`,
        amount: 0,
        name: '',
        flag: true,
      });
    },
    removeCharge(id) {
      // this.response.chargeDetails.charges.splice(
      //   this.response.chargeDetails.charges.findIndex((item) => item.id === id),
      //   1,
      // );
      this.response.chargeDetails.charges.find(
        (item) => item.id === id,
      ).flag = false;
    },
    addNewPayment() {
      this.response.payments.push({
        id: `payment-${nanoid(6)}`,
        amount: 0,
        date: '',
        paymentMethod: null,
        flag: true,
      });
    },
    removePayment(id) {
      // this.response.payments.splice(
      //   this.response.payments.findIndex((item) => item.id === id),
      //   1,
      // );
      this.response.payments.find(
        (item) => item.id === id,
      ).flag = false;
    },
    toggleHazard(idx) {
      const item = this.response.itemDetails.items.find((elem) => elem.id === idx);
      item.hazardous = !item.hazardous;
    },
    calculateVolume(idx) {
      const item = this.response.itemDetails.items.find((elem) => elem.id === idx);
      const length = Number.isNaN(item.length) ? 0 : item.length;
      const width = Number.isNaN(item.width) ? 0 : item.width;
      const height = Number.isNaN(item.height) ? 0 : item.height;
      item.volume = length * width * height;
    },
    countryFormatter(country) {
      if (!country) {
        return '';
      }
      let arr = [];
      const exludeWords = ['of', 'the', 'and'];
      arr = country.split(' ');
      return arr.map((word, i) => (exludeWords.includes(word) && i !== 0 ? [word] : word.charAt(0).toUpperCase() + word.slice(1))).join(' ');
    },
    createShipment() {
      this.processing = true;
      this.processingError = false;
      this.$refs.confirmationModal.show();
      const copy = JSON.parse(JSON.stringify(this.response));
      delete copy.movementStatus;
      copy.itemDetails.shippingTerm = _.lowerCase(copy.itemDetails.shippingTerm);
      copy.pickupDetails.pickupStartTime = `${copy.pickupDetails.pickupStartTime} ${this.pickupStartTime}`;
      copy.pickupDetails.pickupStartTime = moment.tz(copy.pickupDetails.pickupStartTime, this.currentUser.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      copy.pickupDetails.pickupEndTime = `${copy.pickupDetails.pickupEndTime} ${this.pickupEndTime}`;
      copy.pickupDetails.pickupEndTime = moment.tz(copy.pickupDetails.pickupEndTime, this.currentUser.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      copy.itemDetails.items = copy.itemDetails.items.map(({ id, ...rest }) => rest);
      copy.chargeDetails.charges = copy.chargeDetails.charges.map(({ id, ...rest }) => rest);
      copy.payments = copy.payments.map(({ id, date, ...rest }) => rest);
      copy.shipper = Object.fromEntries(Object.entries(copy.shipper)
        .map(([k, v]) => [k, v.toLowerCase().trim()]));
      copy.consignee = Object.fromEntries(Object.entries(copy.consignee)
        .map(([k, v]) => [k, v.toLowerCase().trim()]));
      copy.agent = Object.fromEntries(Object.entries(copy.agent)
        .map(([k, v]) => [k, v.toLowerCase().trim()]));

      copy.itemDetails.items = copy.itemDetails.items.map(
        ({
          optionsWeightType, optionsVolumeType, optionsMeasureType, ...rest
        }) => rest,
      );

      // copy.itemDetails.items = copy.itemDetails.items.map((item) => (
      //   Object.assign(item,
      //     {
      //       packageType: item.packageType.toLowerCase().trim(),
      //       description: item.description.toLowerCase().trim(),
      //       seal: item.seal.toLowerCase().trim(),
      //     })
      // ));

      copy.itemDetails.items = copy.itemDetails.items.map((item) => (
        Object.assign(item,
          {
            packageType: item.packageType.toLowerCase().trim(),
            description: item.description.toLowerCase().trim(),
            seal: item.seal.map((seal) => Object.fromEntries(Object.entries(seal).map(
              ([k, v]) => [k, typeof v === 'string' ? v.toLowerCase() : v],
            ))),
            volume: (Number.isNaN(item.length) ? 0 : item.length)
              * (Number.isNaN(item.width) ? 0 : item.width)
              * (Number.isNaN(item.height) ? 0 : item.height),
          })
      ));

      copy.chargeDetails.charges = copy.chargeDetails.charges.map((item) => (
        Object.assign(item,
          {
            name: item.name.toLowerCase().trim(),
          })
      ));
      copy.pickupDetails.driver = copy.pickupDetails.driver.toLowerCase().trim();

      const data = { data: { ...copy } };
      postShipment(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
          // this.response.id = resp.data.id;
          setTimeout(() => this.$router.push(`/shipment/${resp.data.id}`).then(() => { this.$router.go(0); }), 1000);
        }).catch((err) => {
          this.processingError = err.response.data.error;
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
        });
    },
    updateShipment() {
      this.processing = true;
      this.processingError = false;
      this.$refs.confirmationModal.show();
      const copy = JSON.parse(JSON.stringify(this.response));
      delete copy.movementStatus;
      copy.itemDetails.shippingTerm = _.lowerCase(copy.itemDetails.shippingTerm);
      copy.pickupDetails.pickupStartTime = `${copy.pickupDetails.pickupStartTime} ${this.pickupStartTime}`;
      copy.pickupDetails.pickupStartTime = moment.tz(copy.pickupDetails.pickupStartTime, this.currentUser.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      copy.pickupDetails.pickupEndTime = `${copy.pickupDetails.pickupEndTime} ${this.pickupEndTime}`;
      copy.pickupDetails.pickupEndTime = moment.tz(copy.pickupDetails.pickupEndTime, this.currentUser.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      // copy.itemDetails.items = copy.itemDetails.items.map(({ id, ...rest }) => rest);
      // copy.chargeDetails.charges = copy.chargeDetails.charges.map(({ id, ...rest }) => rest);
      // copy.payments = copy.payments.map(({ id, date, ...rest }) => rest);
      copy.shipper = Object.fromEntries(Object.entries(copy.shipper)
        .map(([k, v]) => [k, v.toLowerCase().trim()]));
      copy.consignee = Object.fromEntries(Object.entries(copy.consignee)
        .map(([k, v]) => [k, v.toLowerCase().trim()]));
      copy.agent = Object.fromEntries(Object.entries(copy.agent)
        .map(([k, v]) => [k, v.toLowerCase().trim()]));

      // copy.itemDetails.items = copy.itemDetails.items.map((item) => (
      //   Object.assign(item,
      //     {
      //       packageType: item.packageType.toLowerCase().trim(),
      //       description: item.description.toLowerCase().trim(),
      //       seal: item.seal.toLowerCase().trim(),
      //     })
      // ));

      copy.itemDetails.items = copy.itemDetails.items.map((item) => (
        Object.assign(item,
          {
            packageType: item.packageType.toLowerCase().trim(),
            description: item.description.toLowerCase().trim(),
            seal: item.seal.map((seal) => Object.fromEntries(Object.entries(seal).map(
              ([k, v]) => [k, typeof v === 'string' ? v.toLowerCase() : v],
            ))),
            volume: (Number.isNaN(item.length) ? 0 : item.length)
              * (Number.isNaN(item.width) ? 0 : item.width)
              * (Number.isNaN(item.height) ? 0 : item.height),
          })
      ));

      copy.chargeDetails.charges = copy.chargeDetails.charges.map((item) => (
        Object.assign(item,
          {
            name: item.name.toLowerCase().trim(),
          })
      ));
      copy.pickupDetails.driver = copy.pickupDetails.driver.toLowerCase().trim();

      const data = { data: { ...copy, shipmentId: this.$route.params.id } };
      updateShipment(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
          setTimeout(() => this.$router.go(0), 1000);
        }).catch((err) => {
          this.processingError = err.response.data.error;
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
        });
    },
    valid() {
      let flag = false;

      this.isStartDateValid = this.response.pickupDetails.pickupStartTime !== null ? null : false;
      if (this.isStartDateValid === false) {
        flag = true;
      }

      this.isEndDateValid = this.response.pickupDetails.pickupEndTime !== null ? null : false;
      if (this.isEndDateValid === false) {
        flag = true;
      }

      this.isStartTimeValid = this.pickupStartTime !== null ? null : false;
      if (this.isStartTimeValid === false) {
        flag = true;
      }
      this.isEndTimeValid = this.pickupEndTime !== null ? null : false;
      if (this.isEndTimeValid === false) {
        flag = true;
      }

      if (this.outstandingBalance < 0) {
        flag = true;
        this.processingError = 'Can not have a negative outstanding balance';
        this.$refs.confirmationModal.show();
        setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
      }

      if (flag) {
        return;
      }

      if (this.$route.params.id) {
        this.updateShipment();
      } else {
        this.createShipment();
      }
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      if (toDepth < fromDepth) {
        this.reset();
      }
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();

    this.accountNumber = this.$route.query.accountNumber === undefined ? '' : this.$route.query.accountNumber;
    this.bol = this.$route.query.bol === undefined ? '' : this.$route.query.bol;
    this.phoneNumber = this.$route.query.phoneNumber === undefined ? '' : this.$route.query.phoneNumber;
    this.name = this.$route.query.name === undefined ? '' : this.$route.query.name;
    this.destination = this.$route.query.destination === undefined ? '' : this.$route.query.destination;

    if (this.$route.params.id) {
      getShipmentById(this.$route.params.id)
        .then((res) => {
          this.response = res.data.result;
          // Patch types from response
          this.response.payments = this.response.payments.map((p) => ({
            ...p,
            paidDate: new Date(p.paidDate).toISOString().split('T')[0],
            paymentMethod: p.paymentMethod,
            amount: +p.amount,
          }));
          this.response.chargeDetails.charges = this.response.chargeDetails.charges
            .map((charge) => ({
              ...charge,
              amount: +charge.amount,
            }));

          this.response.shipper.country = this.countryFormatter(this.response.shipper.country);
          this.response.consignee.country = this.countryFormatter(this.response.consignee.country);
          this.response.agent.country = this.countryFormatter(this.response.agent.country);

          this.response.pickupDetails.pickupStartTime = moment.tz(
            this.response.pickupDetails.pickupStartTime, this.currentUser.timezone,
          );
          this.response.pickupDetails.pickupEndTime = moment.tz(
            this.response.pickupDetails.pickupEndTime, this.currentUser.timezone,
          );

          this.pickupStartTime = this.response.pickupDetails.pickupStartTime.format('HH:mm:ss');
          this.pickupEndTime = this.response.pickupDetails.pickupEndTime.format('HH:mm:ss');
          this.response.pickupDetails.pickupStartTime = this.response.pickupDetails.pickupStartTime.format('YYYY-MM-DD');
          this.response.pickupDetails.pickupEndTime = this.response.pickupDetails.pickupEndTime.format('YYYY-MM-DD');

          this.dateCreated = new Date(this.response.pickupDetails.dateCreated).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' });
          // this.response.itemDetails.shippingTerm = this.response.itemDetails.type;
          // delete this.response.itemDetails.type;
          // Fix mismatching enum response
          this.response.itemDetails.shippingTerm = this.response.itemDetails.shippingTerm === 'moved' ? _.camelCase('door to door') : _.camelCase(this.response.itemDetails.shippingTerm);
          this.response.movementStatus = this.response.movement_status;
          delete this.response.movement_status;
          // Fill missing API values
          this.response.itemDetails.items = this.response.itemDetails.items.map((item) => ({
            ...item,
            packageType: item.packageType,
            hazardous: !!item.hazardous,
            selectedWeightType: 'lbs',
            optionsWeightType: [
              { value: 'lbs', text: 'lbs' },
              // { value: 'kgs', text: 'kgs' },
              // { value: 'tons', text: 'tons' },
            ],
            selectedVolumeType: 'in3',
            optionsVolumeType: [
              { value: 'in3', text: 'in3' },
              // { value: 'm3', text: 'meters3' },
            ],
            selectedMeasureType: 'in',
            optionsMeasureType: [
              { value: 'in', text: 'in' },
              // { value: 'm', text: 'meters' },
            ],
          }));
          // Correct typo in response
          this.response.movementStatus = this.response.movementStatus === 'Delivering' ? 'Shipping' : this.response.movementStatus;
          // this.loading = false;
          // this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.error = true;
        });
    }// else {
    //   this.loading = false;
    //   this.error = false;
    // }
    console.log(this.$route.params.id);
    tokenize({ data: { id: this.$route.params.id } }).then((res) => {
      this.token = res.data.result;
    }).catch(() => {
    });
    getOffice().then((resp) => {
      console.log('Successfully GETed');
      this.agents = resp.data.result;
      this.loading = false;
      this.error = false;
    }).catch((err) => {
      console.log(err);
      this.loading = false;
      this.error = true;
    });
  },
  components: {
    BOLReceipt,
    WarehouseReceipt,
    BOLLabel,
    Loading,
    Checkmark,
    vSelect,
    ShipmentNavProgress,
    ShipmentStatusProgress,
    ShipmentPrototypePaymentList,
    ShipmentPrototypeItemList,
    ShipmentPrototypeChargesList,
    ShipmentPrototypeCard,
    Cross,
  },
};
</script>

<style scoped lang="scss">
@import '../assets/styles/floatingLabel.scss';

#pdf {
  width: 100%;
  height: 100%;
}

.shipment-option {
  height: 3em;
  width: 3em;
  padding: 0;
  border-radius: 50%;
  margin: 0 10px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  background: #7da3c7;
  outline: none;
  border: none;
}

.shipment-option:hover {
  background: #608cb3;
}

.shipment-create-button {
  background: #7da3c7;
  border: none;
}

.shipment-create-button:hover {
  background: #608cb3;
}

.normalize {
  outline: none;
  box-shadow: none;
  background-color: transparent;
  border: none;
  padding-left: 0;
  padding-right: 0;
}

.normalize:focus, .normalize:active {
  outline: none;
  box-shadow: none !important;
  background-color: transparent !important;
  border: none;
}

.shipment-list-item {
  padding: 10px 0;
  color: #4c4c4c;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shipment-list-item:hover {
  background: #f5f5f5;
  border-radius: 0;
}

h6, h5 {
  margin-bottom: 0;
}

#shipment-scrollspy li {
  position: relative;
}

#shipment-scrollspy li:after {
  content: '.';
  display: block;
  position: absolute;
  top: 0.35em;
  right: 5px;
}

[v-cloak] {
  display: none;
}

::v-deep .b-time {
  width: 100%;
}
</style>

<style>
html {
  scroll-behavior: smooth;
}

.left-15 {
  left: 15px;
}
</style>
